var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDisplayed)?_c('iw-input-checkbox',{attrs:{"input-label":_vm.$t('swimming_pool'),"name":"has-swimming-pool"},model:{value:(_vm.hasSwimmingPool),callback:function ($$v) {_vm.hasSwimmingPool=$$v},expression:"hasSwimmingPool"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }